import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { PLATFORM } from '../../app.constants';
import { NetworkStatusService } from '../../_services/network-status.service';
import { platform } from '../../../platform/platform';
import { LoginUserService } from '../../_services/http-api/login-user.service';

@Injectable({
  providedIn: 'root'
})
export class VisolAppAdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private loginUserService: LoginUserService,
    private networkStatusService: NetworkStatusService) {
  }

  private get isOffline() {
    return this.networkStatusService.isOffline;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isOffline
      ? true
      : this.loginUserService.isAdminRole();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isOffline
      ? true
      : this.loginUserService.isAdminRole();
  }

}
